import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import Block from '../../styles/common/Block';
import Title from '../../styles/common/Title';
import HeaderNotice from '../Parts/HeaderNotice';
import UserInfo from '../UserInfo/UserInfo';
import MediaDetail from '../Media/MediaDetail';
import closeButton from '../../images/common/close.svg';
import {
  toggleMediaFullscreen,
  toggleMediaMap,
  toggleMore,
  restoreWorkRecords,
  deleteWorkRecords,
} from '../../actions/trash';
import UserPrompt from '../UserPrompt';

const TrashMediaTitle = styled(Title)`
  justify-content: space-between;
`;

const CloseButtonImage = styled.img`
  width: 20px;
  height: 20px;
`;

const TrashMediaPage = ({
  mediaDetailHeight,
  apiToken,
  dispatch,
  userInfo,
  openUserInfo,
  innerRole,
  license,
  operators,
  history,
  trashMediaInfo,
  userGroups,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    info,
    mediaFullScreenMode,
    mediaMapFullScreenMode,
    isOpenAnalysis,
    isOpenMore,
  } = trashMediaInfo;
  return (
    <Block>
      {openUserInfo && (
        <UserInfo
          userInfo={userInfo}
          openUserInfo={openUserInfo}
          onClose={() => dispatch({ type: 'CLOSE_USER_INFO_DIALOG' })}
        />
      )}
      <UserPrompt />
      <HeaderNotice msg={formatMessage({ id: 'trash.headerNotice' })} />
      <TrashMediaTitle id="title">
        <div>
          <FormattedMessage id="trash.media.title" />
        </div>
        <CloseButtonImage
          id="mediaCloseButton"
          role="presentation"
          src={closeButton}
          alt="closeButton"
          className="button"
          onClick={() => history.push('/trash')}
        />
      </TrashMediaTitle>
      <MediaDetail
        mediaDetailHeight={mediaDetailHeight}
        innerRole={innerRole}
        mediaInfo={info}
        operators={operators}
        license={license}
        mediaFullScreenMode={mediaFullScreenMode}
        mediaMapFullScreenMode={mediaMapFullScreenMode}
        isOpenMore={isOpenMore}
        isOpenAnalysis={isOpenAnalysis}
        userGroups={userGroups}
        onChangePage={searchPosition =>
          dispatch({ type: 'UPDATE_SEARCH_POSITION', searchPosition })
        }
        onToggleAction={() => toggleMore(dispatch)}
        onRestore={() =>
          restoreWorkRecords(dispatch, apiToken, formatMessage, history, [
            info.id,
          ])
        }
        onCompleteDelete={() => {
          deleteWorkRecords(dispatch, apiToken, formatMessage, history, [
            info.id,
          ]);
        }}
        onToggleResult={() => toggleMediaFullscreen(dispatch)}
        onToggleMap={() => toggleMediaMap(dispatch)}
      />
    </Block>
  );
};

TrashMediaPage.propTypes = {
  mediaDetailHeight: PropTypes.number.isRequired,
  apiToken: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
  openUserInfo: PropTypes.bool.isRequired,
  innerRole: PropTypes.number.isRequired,
  license: PropTypes.object.isRequired,
  operators: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  trashMediaInfo: PropTypes.object.isRequired,
  userGroups: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  userInfo: state.main.userInfo,
  openUserInfo: state.main.openUserInfo,
  innerRole: state.main.innerRole,
  license: state.main.license,
  operators: state.operator.operators,
  trashMediaInfo: state.trash.trashMediaInfo,
  userGroups: state.main.userGroups,
});

export default withRouter(connect(mapStateToProps)(TrashMediaPage));
